<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="next-btn">
    <div class="box" @click="updateProgressTracker">
      {{ text }}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressTracker from "@/services/ProgressTracker";
import * as Sentry from "@sentry/browser";

export default {
  name: "NextButton",
  props: {
    url: String,
    text: String
  },
  methods: {
    async updateProgressTracker() {
      try {
        await ProgressTracker.updateTracker();
        this.$emit("click");
        this.$router.push(this.url);
      } catch (err) {
        Sentry.configureScope(function (user) {
          user.setUser({ id: localStorage.getItem("id") });
          user.setTag("immersion", 1);
          user.setTag("phase", "Update Progress tracker");
          user.setLevel("error");
        });
        Sentry.captureException(err);
      }
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.box {
  padding: 5px 40px;
  border-radius: 5px;
  background-color: #5e2a57;
  width: 400px;
  font-size: 26px;
  margin: auto;
  color: white;
  cursor: pointer;
  text-align: center;
}
.box:hover {
  background-color: #3b1a36;
  border-color: #32162e;
}
</style>
